export const read_about_arthelper = {
  type: 'thinking',
  call: () => null,
  'partial-call': () => null,
  result: () => null,
};
